import { create } from 'zustand';

function getStoredShowDeclinedEvents(): boolean {
  try {
    return JSON.parse(localStorage.getItem('showDeclinedEvents') || 'false') === true;
  } catch {
    // Corrupt localStorage value — don't let it crash store creation at app startup.
    return false;
  }
}

const useSettingsStore = create((set: any) => ({
  showDeclinedEvents: getStoredShowDeclinedEvents(),
  toggleShowDeclinedEvents: () =>
    set((state: any) => {
      const newValue = !state.showDeclinedEvents;
      localStorage.setItem('showDeclinedEvents', JSON.stringify(newValue));
      return { showDeclinedEvents: newValue };
    }),
}));

export default useSettingsStore;
